// src/pages/FlashVendas.jsx
import React, { useEffect, useState, useRef, memo, useCallback } from 'react';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { useNavigate } from "react-router-dom";
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import './flash.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  ArcElement
);

const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const generateUniqueColors = (count) => {
  const colors = [];
  const generated = new Set();
  while (colors.length < count) {
    const c = getRandomColor();
    if (!generated.has(c)) { colors.push(c); generated.add(c); }
  }
  return colors;
};

const formatCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(value ?? 0);

const MetaMesProgresso = ({ percentual }) => {
  const pct = Math.min(Math.max(percentual || 0, 0), 100);
  return (
    <div className="bottle-wrapper">
      <div className="bottle-cap"></div>
      <div className="bottle-container" title={`Meta do Mês: ${pct.toFixed(1)}%`}>
        <div className="bottle-fill" style={{ height: `${pct}%` }}></div>
      </div>
      <span className="bottle-badge">{pct.toFixed(1)}%</span>
    </div>
  );
};

const DoubleDoughnutChart = memo(({ percPrincipal, percQuebra, corPrincipal }) => {
  const data = {
    datasets: [
      {
        data: [Math.max(0, Math.min(100, percPrincipal)), 100 - Math.max(0, Math.min(100, percPrincipal))],
        backgroundColor: [corPrincipal, 'rgba(226, 232, 240, 0.6)'],
        borderWidth: 0,
        cutout: '76%'
      },
      {
        data: [Math.max(0, Math.min(100, percQuebra)), 100 - Math.max(0, Math.min(100, percQuebra))],
        backgroundColor: ['#991b1b', 'rgba(226, 232, 240, 0.6)'],
        borderWidth: 0,
        cutout: '62%'
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
      datalabels: { display: false }
    }
  };

  return (
    <div style={{ position: 'relative', width: 75, height: 75, margin: '0 auto' }}>
      <Doughnut data={data} options={options} />
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '0.65rem',
        fontWeight: '800',
        textAlign: 'center',
        lineHeight: '1.1'
      }}>
        <span style={{ color: corPrincipal }}>{percPrincipal.toFixed(1)}%</span>
        <br />
        <span style={{ color: '#991b1b', fontSize: '0.58rem' }}>{percQuebra.toFixed(1)}%</span>
      </div>
    </div>
  );
});

function ModalGenerico({ show, onClose, title, children }) {
  if (!show) return null;
  return (
    <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(15, 23, 42, 0.75)', zIndex: 1200, backdropFilter: 'blur(4px)' }}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '14px', overflow: 'hidden' }}>
          {/* 🔹 Alterado de bg-dark para bg-custom-red */}
          <div className="modal-header bg-custom-red text-white py-3 px-4">
            <h5 className="modal-title font-weight-bold fs-6">{title}</h5>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body p-4">{children}</div>
          <div className="modal-footer bg-light py-2 px-4">
            <button type="button" className="btn btn-custom-red btn-sm px-4 fw-semibold" onClick={onClose}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ChartZoomModal({ show, onClose, title, children }) {
  if (!show) return null;
  return (
    <div className="chart-zoom-modal-overlay">
      <div className="chart-zoom-modal-content">
        <div className="chart-zoom-modal-header">
          <h5 className="m-0 fs-6 fw-bold">{title}</h5>
          <button type="button" className="btn-close" onClick={onClose}></button>
        </div>
        <div className="chart-zoom-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}

{/* 🔹 COMPONENTE DE LOADING PADRONIZADO (Baseado no Print 3) */ }
function LoadingModal({ show, message }) {
  if (!show) return null;
  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal-content">
        <div className="spinner-border text-custom-red" role="status" style={{ width: '2.5rem', height: '2.5rem' }}>
          <span className="visually-hidden">A carregar...</span>
        </div>
        <div className="loading-text mt-3 fw-bold text-secondary">{message}</div>
      </div>
    </div>
  );
}

const FloatingClock = ({ seconds }) => {
  const formatTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const remaining = secs % 60;
    return `${minutes.toString().padStart(2, '0')}:${remaining.toString().padStart(2, '0')}`;
  };
  return (
    <div className="floating-clock-compact" title="Tempo restante para atualização automática">
      <i className="fa fa-refresh me-1 opacity-75"></i>
      <span>{formatTime(seconds)}</span>
    </div>
  );
};

// Componente SecaoGrafico
const SecaoGrafico = memo(({ data, lojaDescricao, lojaId, isMobile, onExpandSecao, onOpenTiposPerda }) => {
  const [tipoVisao, setTipoVisao] = useState('DIA');
  const chartRef = useRef(null);

  if (!data || data.length === 0) return <div className="text-muted text-center py-3">Nenhuma seção encontrada.</div>;

  const colors = generateUniqueColors(data.length);

  const getValue = (s) => {
    if (tipoVisao === 'PERIODO') return s.atingido_acum ?? 0;
    if (tipoVisao === 'MES') return s.pct_garrafa ?? 0;
    if (tipoVisao === 'Q_DIA') return s.pct_perda_dia ?? s.PCT_PERDA_DIA ?? 0;
    if (tipoVisao === 'Q_PERIODO') return s.pct_perda_periodo ?? s.PCT_PERDA_PERIODO ?? 0;
    return s.atingido ?? 0;
  };

  const getTitle = () => {
    if (tipoVisao === 'PERIODO') return `% Atingido Período por Seção - ${lojaDescricao}`;
    if (tipoVisao === 'MES') return `% Meta Mês por Seção - ${lojaDescricao}`;
    if (tipoVisao === 'Q_DIA') return `% Quebra Dia por Seção - ${lojaDescricao}`;
    if (tipoVisao === 'Q_PERIODO') return `% Quebra Período por Seção - ${lojaDescricao}`;
    return `% Atingido Meta Dia por Seção - ${lojaDescricao}`;
  };

  const chartData = {
    labels: data.map(s => s.descricao || s.DESCRICAO || `Seção ${s.codsecao || s.CODSECAO}`),
    datasets: [{
      label: getTitle(),
      data: data.map(s => getValue(s)),
      backgroundColor: (tipoVisao === 'Q_DIA' || tipoVisao === 'Q_PERIODO') ? 'rgba(153, 27, 27, 0.85)' : colors,
      borderColor: (tipoVisao === 'Q_DIA' || tipoVisao === 'Q_PERIODO') ? 'rgba(128, 0, 0, 1)' : colors,
      borderWidth: 1,
      borderRadius: 4,
      secaoData: data
    }]
  };

  const handleBarClick = (event) => {
    if (!chartRef.current) return;
    const chart = chartRef.current;
    const active = chart.getElementsAtEventForMode
      ? chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, false)
      : [];

    if (active.length > 0) {
      const idx = active[0].index;
      const secaoObj = data[idx];

      const codSecao =
        secaoObj.seqcategoria ??
        secaoObj.SEQCATEGORIA ??
        secaoObj.codsecao ??
        secaoObj.CODSECAO ??
        secaoObj.cod_secao ??
        secaoObj.COD_SECAO ??
        secaoObj.secao ??
        secaoObj.SECAO ??
        0;

      const descSecao = secaoObj.descricao ?? secaoObj.DESCRICAO ?? `Seção ${codSecao}`;

      if (tipoVisao === 'Q_DIA' || tipoVisao === 'Q_PERIODO') {
        const tipoQuebra = tipoVisao === 'Q_DIA' ? 'DIA' : 'PERIODO';
        onOpenTiposPerda(lojaId, tipoQuebra, codSecao, descSecao);
      }
    }
  };

  const options = {
    responsive: true,
    indexAxis: 'y',
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: { display: true, text: getTitle(), font: { size: isMobile ? 12 : 13, weight: 'bold' }, color: '#1e293b' },
      tooltip: {
        backgroundColor: '#0f172a',
        padding: 8,
        callbacks: {
          title: (items) => items && items[0] ? `Seção: ${items[0].label}` : '',
          label: (ctx) => {
            const secaoData = ctx.dataset.secaoData ? ctx.dataset.secaoData[ctx.dataIndex] : null;
            if (!secaoData) return `${ctx.dataset.label}: ${ctx.raw}`;

            const margemDia = (secaoData.margem ?? 0).toFixed(2);
            const margemAcum = (secaoData.margem_acum ?? 0).toFixed(2);

            const vlrPerdaDia = secaoData.vlr_perda_dia ?? secaoData.VLR_PERDA_DIA ?? 0;
            const vlrPerdaPeriodo = secaoData.vlr_perda_periodo ?? secaoData.VLR_PERDA_PERIODO ?? 0;

            if (tipoVisao === 'Q_DIA') {
              return [
                `Valor Quebra Dia: ${formatCurrency(vlrPerdaDia)}`,
                `% Quebra Dia: ${(secaoData.pct_perda_dia ?? secaoData.PCT_PERDA_DIA ?? 0).toFixed(2)}%`,
                `Clique para ver os tipos de quebra`
              ];
            } else if (tipoVisao === 'Q_PERIODO') {
              return [
                `Valor Quebra Período: ${formatCurrency(vlrPerdaPeriodo)}`,
                `% Quebra Período: ${(secaoData.pct_perda_periodo ?? secaoData.PCT_PERDA_PERIODO ?? 0).toFixed(2)}%`,
                `Clique para ver os tipos de quebra`
              ];
            } else if (tipoVisao === 'PERIODO') {
              return [
                `Venda Mês: ${formatCurrency(secaoData.vlrvenda_acum)}`,
                `Meta Período: ${formatCurrency(secaoData.vlr_meta_acum)}`,
                `% Atingido Período: ${(secaoData.atingido_acum ?? 0).toFixed(2)}%`,
                `Margem Período: ${margemAcum}%`
              ];
            } else if (tipoVisao === 'MES') {
              return [
                `Venda Mês: ${formatCurrency(secaoData.vlrvenda_acum)}`,
                `Meta Mês: ${formatCurrency(secaoData.vlr_meta_mes)}`,
                `% Meta Mês: ${(secaoData.pct_garrafa ?? 0).toFixed(2)}%`,
                `Margem Mês: ${margemAcum}%`
              ];
            }
            return [
              `Venda Dia: ${formatCurrency(secaoData.vl_vda)}`,
              `Meta Dia: ${formatCurrency(secaoData.vlr_meta_dia)}`,
              `% Atingido Dia: ${(secaoData.atingido ?? 0).toFixed(2)}%`,
              `Margem Dia: ${margemDia}%`
            ];
          }
        }
      },
      datalabels: { color: '#0f172a', font: { weight: 'bold', size: isMobile ? 8 : 9 }, anchor: 'end', align: 'right', formatter: (v) => `${(v ?? 0).toFixed(1)}%` }
    },
    scales: {
      x: { beginAtZero: true, title: { display: true, text: 'Percentual (%)', font: { weight: '600', size: 10 } }, ticks: { callback: (val) => val + '%', font: { size: 9 } }, grid: { color: '#f1f5f9' } },
      y: { title: { display: isMobile, text: 'Seção' }, ticks: { font: { size: 9 } }, grid: { display: false } }
    }
  };

  const dynamicHeight = Math.max(200, data.length * 26);

  return (
    <div className="position-relative border p-2 rounded-3 bg-white mt-2 shadow-sm">
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 gap-2">
        <div className="btn-group btn-group-sm shadow-sm" role="group">
          <button
            type="button"
            className={`btn btn-xs ${tipoVisao === 'DIA' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setTipoVisao('DIA')}
          >
            Dia
          </button>
          <button
            type="button"
            className={`btn btn-xs ${tipoVisao === 'PERIODO' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setTipoVisao('PERIODO')}
          >
            Período
          </button>
          <button
            type="button"
            className={`btn btn-xs ${tipoVisao === 'MES' ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setTipoVisao('MES')}
          >
            Mês
          </button>
          <button
            type="button"
            className={`btn btn-xs ${tipoVisao === 'Q_DIA' ? 'btn-custom-red' : 'btn-outline-custom-red'}`}
            onClick={() => setTipoVisao('Q_DIA')}
          >
            Q. Dia
          </button>
          <button
            type="button"
            className={`btn btn-xs ${tipoVisao === 'Q_PERIODO' ? 'btn-custom-red' : 'btn-outline-custom-red'}`}
            onClick={() => setTipoVisao('Q_PERIODO')}
          >
            Q. Período
          </button>
        </div>

        <button
          className="btn btn-xs btn-outline-secondary font-weight-semibold"
          onClick={() => onExpandSecao(data, lojaDescricao, tipoVisao)}
        >
          🔍 Expandir
        </button>
      </div>

      <div className="secao-chart-container" style={{ height: `${dynamicHeight}px` }}>
        <Bar ref={chartRef} options={options} data={chartData} onClick={handleBarClick} />
      </div>
    </div>
  );
});

const FlashVendas = () => {
  const [vendas, setVendas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState('A carregar dados...');
  const [error, setError] = useState(null);
  const [timerSeconds, setTimerSeconds] = useState(150);
  const [expandedLojas, setExpandedLojas] = useState([]);
  const [secoesData, setSecoesData] = useState({});
  const [secoesLoading, setSecoesLoading] = useState({});

  const [zoomChart, setZoomChart] = useState(null);
  const [zoomSecao, setZoomSecao] = useState(null);

  const [activeTabMobile, setActiveTabMobile] = useState('dia');

  const [showTiposModal, setShowTiposModal] = useState(false);
  const [tiposPerdaData, setTiposPerdaData] = useState([]);
  const [loadingPerdas, setLoadingPerdas] = useState(false);
  const [selectedLojaPerda, setSelectedLojaPerda] = useState('');
  const [selectedTipoQuebra, setSelectedTipoQuebra] = useState('DIA');
  const [selectedSecaoPerda, setSelectedSecaoPerda] = useState(0);
  const [selectedSecaoNome, setSelectedSecaoNome] = useState('');

  const [showProdutosModal, setShowProdutosModal] = useState(false);
  const [produtosPerdaData, setProdutosPerdaData] = useState([]);
  const [modalProdutosTitle, setModalProdutosTitle] = useState('');

  const [ordemTipos, setOrdemTipos] = useState('VALOR_DESC');
  const [ordemProdutos, setOrdemProdutos] = useState('VALOR_DESC');

  const isFetchingRef = useRef(false);
  const nextFetchTimeRef = useRef(Date.now() + 150000);
  const expandedLojasRef = useRef([]);

  const isMobile = window.innerWidth <= 768;
  const navigate = useNavigate();
  const chartRef = useRef(null);

  useEffect(() => { expandedLojasRef.current = expandedLojas; }, [expandedLojas]);

  const resetTimer = useCallback(() => {
    nextFetchTimeRef.current = Date.now() + 150000;
    setTimerSeconds(150);
  }, []);

  useEffect(() => {
    const chapa = localStorage.getItem("chapa");
    const permiteVendas = localStorage.getItem("permiteVendas");
    if (!chapa) {
      navigate("/arbor/login");
    } else if (permiteVendas !== "S") {
      Swal.fire({ icon: 'error', title: 'Acesso Negado', text: 'Não é permitido acessar as vendas.', confirmButtonText: 'OK' })
        .then(() => navigate("/arbor/home"));
    }
  }, [navigate]);

  const fetchVendas = useCallback(async (showLoading = true) => {
    if (isFetchingRef.current) return;
    const permiteVendas = localStorage.getItem("permiteVendas");
    if (permiteVendas !== "S") return;

    try {
      isFetchingRef.current = true;
      if (showLoading) { setLoading(true); setLoadingMessage('A carregar dados...'); }
      const chapa = localStorage.getItem("chapa");
      const res = await api.get('/venda/flashvenda', { params: { usuario: chapa } });

      const normalizedData = (res.data || []).map(v => ({
        ...v,
        vl_vda: v.vl_vda ?? v.VL_VDA ?? 0,
        vlr_meta_dia: v.vlr_meta_dia ?? v.VLR_META_DIA ?? 0,
        atingido: v.atingido ?? v.ATINGIDO ?? 0,
        vlr_perda_dia: v.vlr_perda_dia ?? v.VLR_PERDA_DIA ?? 0,
        pct_perda_dia: v.pct_perda_dia ?? v.PCT_PERDA_DIA ?? 0,
        vlrvendapromoc: v.vlrvendapromoc ?? v.VLRVENDAPROMOC ?? 0,
        vlrlucro: v.vlrlucro ?? v.VLRLUCRO ?? 0,
        vlrvenda_acum: v.vlrvenda_acum ?? v.VLRVENDA_ACUM ?? 0,
        vlr_meta_acum: v.vlr_meta_acum ?? v.VLR_META_ACUM ?? 0,
        atingido_acum: v.atingido_acum ?? v.ATINGIDO_ACUM ?? 0,
        vlr_perda_periodo: v.vlr_perda_periodo ?? v.VLR_PERDA_PERIODO ?? 0,
        pct_perda_periodo: v.pct_perda_periodo ?? v.PCT_PERDA_PERIODO ?? 0,
        vlr_meta_mes: v.vlr_meta_mes ?? v.VLR_META_MES ?? 0,
        pct_garrafa: v.pct_garrafa ?? v.PCT_GARRAFA ?? 0,
        margem_acum: v.margem_acum ?? v.MARGEM_ACUM ?? 0
      }));

      setVendas(normalizedData);
      setError(null);
    } catch (err) {
      console.error('Erro ao buscar dados de vendas:', err);
      if (showLoading) {
        Swal.fire('Erro', 'Não foi possível carregar os dados de vendas.', 'error');
        setError('Não foi possível carregar os dados de vendas.');
      }
    } finally {
      isFetchingRef.current = false;
      if (showLoading) setLoading(false);
    }
  }, []);

  const fetchSecoes = useCallback(async (loja) => {
    resetTimer();
    setSecoesLoading(prev => ({ ...prev, [loja]: true }));
    try {
      const chapa = localStorage.getItem("chapa");
      const res = await api.get('/venda/flashsecao', { params: { loja: loja, usuario: chapa } });
      setSecoesData(prev => ({ ...prev, [loja]: res.data || [] }));
    } catch (err) {
      console.error('Erro ao buscar dados de seções:', err);
      setSecoesData(prev => ({ ...prev, [loja]: [] }));
    } finally {
      setSecoesLoading(prev => ({ ...prev, [loja]: false }));
    }
  }, [resetTimer]);

  const fetchSecoesTotal = useCallback(async () => {
    resetTimer();
    setSecoesLoading(prev => ({ ...prev, Emp: true }));
    try {
      const chapa = localStorage.getItem("chapa");
      const res = await api.get('/venda/flashsecaototal', { params: { usuario: chapa } });
      setSecoesData(prev => ({ ...prev, Emp: res.data || [] }));
    } catch (err) {
      console.error("Erro ao buscar seções totais:", err);
      setSecoesData(prev => ({ ...prev, Emp: [] }));
    } finally {
      setSecoesLoading(prev => ({ ...prev, Emp: false }));
    }
  }, [resetTimer]);

  const refreshAllData = useCallback(async () => {
    if (isFetchingRef.current) return;
    resetTimer();
    await fetchVendas(false);

    expandedLojasRef.current.forEach(loja => {
      if (loja === "Emp") {
        fetchSecoesTotal();
      } else {
        fetchSecoes(loja);
      }
    });
  }, [fetchVendas, fetchSecoes, fetchSecoesTotal, resetTimer]);

  useEffect(() => {
    fetchVendas(true);
    resetTimer();

    const interval = setInterval(() => {
      if (isFetchingRef.current) return;

      const now = Date.now();
      const remaining = Math.max(0, Math.ceil((nextFetchTimeRef.current - now) / 1000));
      setTimerSeconds(remaining);

      if (remaining <= 0) {
        refreshAllData();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [fetchVendas, refreshAllData, resetTimer]);

  const handleOpenTiposPerda = async (lojaId, tipo, codSecao = 0, secaoNome = '') => {
    resetTimer();
    const empId = lojaId === 'Emp' ? '' : lojaId;
    const numSecao = Number(codSecao) || 0;

    setSelectedLojaPerda(empId);
    setSelectedTipoQuebra(tipo);
    setSelectedSecaoPerda(numSecao);
    setSelectedSecaoNome(secaoNome);

    setLoadingPerdas(true);
    setShowTiposModal(true);

    try {
      const res = await api.get('/venda/perdas/tipos', {
        params: {
          loja: empId,
          tipo: tipo,
          codsecao: numSecao,
          secao: numSecao
        }
      });
      setTiposPerdaData(res.data || []);
    } catch (err) {
      console.error("Erro ao buscar tipos de perda:", err);
      setTiposPerdaData([]);
    } finally {
      setLoadingPerdas(false);
    }
  };

  const handleOpenProdutosPorTipo = async (codGeralOper, tipoNome) => {
    resetTimer();
    const nomeExibicao = tipoNome || `Operação ${codGeralOper}`;
    const sufixoSecao = selectedSecaoNome ? ` - Seção: ${selectedSecaoNome}` : '';

    setLoadingPerdas(true);
    setModalProdutosTitle(`Produtos - ${nomeExibicao} (${selectedTipoQuebra})${sufixoSecao}`);
    setShowProdutosModal(true);

    try {
      const res = await api.get('/venda/perdas/produtos', {
        params: {
          loja: selectedLojaPerda,
          tipo: selectedTipoQuebra,
          codgeraloper: codGeralOper,
          codsecao: selectedSecaoPerda,
          secao: selectedSecaoPerda
        }
      });
      setProdutosPerdaData(res.data || []);
    } catch (err) {
      console.error("Erro ao buscar produtos da perda:", err);
      setProdutosPerdaData([]);
    } finally {
      setLoadingPerdas(false);
    }
  };

  const getTiposPerdaOrdenados = () => {
    const lista = [...tiposPerdaData];
    return lista.sort((a, b) => {
      const valorA = a.VLRTOTALLANCTOBRT ?? a.vlrtotallanctobrt ?? a.VLRTOTALLANCTOBRTPERIODO ?? a.vlrtotallanctobrtperiodo ?? 0;
      const valorB = b.VLRTOTALLANCTOBRT ?? b.vlrtotallanctobrt ?? b.VLRTOTALLANCTOBRTPERIODO ?? b.vlrtotallanctobrtperiodo ?? 0;
      const nomeA = (a.TIPO || a.tipo || '').toLowerCase();
      const nomeB = (b.TIPO || b.tipo || '').toLowerCase();

      if (ordemTipos === 'VALOR_DESC') return valorB - valorA;
      if (ordemTipos === 'VALOR_ASC') return valorA - valorB;
      if (ordemTipos === 'NOME_ASC') return nomeA.localeCompare(nomeB);
      if (ordemTipos === 'NOME_DESC') return nomeB.localeCompare(nomeA);
      return 0;
    });
  };

  const getProdutosPerdaOrdenados = () => {
    const lista = [...produtosPerdaData];
    return lista.sort((a, b) => {
      const valorA = a.VALORTOTAL ?? a.valortotal ?? a.VALORLANCTOBRT ?? a.valorlanctobrt ?? 0;
      const valorB = b.VALORTOTAL ?? b.valortotal ?? b.VALORLANCTOBRT ?? b.valorlanctobrt ?? 0;
      const nomeA = (a.DESCRICAO || a.descricao || a.DESCCOMPLETA || a.desccompleta || '').toLowerCase();
      const nomeB = (b.DESCRICAO || b.descricao || b.DESCCOMPLETA || b.desccompleta || '').toLowerCase();

      if (ordemProdutos === 'VALOR_DESC') return valorB - valorA;
      if (ordemProdutos === 'VALOR_ASC') return valorA - valorB;
      if (ordemProdutos === 'NOME_ASC') return nomeA.localeCompare(nomeB);
      if (ordemProdutos === 'NOME_DESC') return nomeB.localeCompare(nomeA);
      return 0;
    });
  };

  const handleLojaClick = (loja) => {
    const open = expandedLojas.includes(loja);
    if (open) {
      setExpandedLojas(prev => prev.filter(l => l !== loja));
      return;
    }

    setExpandedLojas(prev => [...prev, loja]);
    if (loja === "Emp") {
      fetchSecoesTotal();
    } else {
      fetchSecoes(loja);
    }
  };

  const isExpanded = (loja) => expandedLojas.includes(loja);

  const totalVenda = vendas.reduce((s, v) => s + (v.vl_vda ?? 0), 0);
  const totalMeta = vendas.reduce((s, v) => s + (v.vlr_meta_dia ?? 0), 0);
  const totalQuebraDia = vendas.reduce((s, v) => s + (v.vlr_perda_dia ?? 0), 0);
  const totalVendaPromoc = vendas.reduce((s, v) => s + (v.vlrvendapromoc ?? 0), 0);
  const totalLucro = vendas.reduce((s, v) => s + (v.vlrlucro ?? 0), 0);
  const totalAtingido = totalMeta > 0 ? (totalVenda / totalMeta) * 100 : 0;
  const totalPctQuebraDia = totalVenda > 0 ? (totalQuebraDia / totalVenda) * 100 : 0;
  const percPromoPorLinha = (v) => v.vl_vda > 0 ? (v.vlrvendapromoc / v.vl_vda) * 100 : 0;

  const totalVendaAcum = vendas.reduce((s, v) => s + (v.vlrvenda_acum ?? 0), 0);
  const totalMetaAcum = vendas.reduce((s, v) => s + (v.vlr_meta_acum ?? 0), 0);
  const totalQuebraAcum = vendas.reduce((s, v) => s + (v.vlr_perda_periodo ?? 0), 0);
  const totalAtingidoAcum = totalMetaAcum > 0 ? (totalVendaAcum / totalMetaAcum) * 100 : 0;
  const totalPctQuebraAcum = totalVendaAcum > 0 ? (totalQuebraAcum / totalVendaAcum) * 100 : 0;
  const totalMetaMes = vendas.reduce((s, v) => s + (v.vlr_meta_mes ?? 0), 0);
  const totalPctGarrafa = totalMetaMes > 0 ? (totalVendaAcum / totalMetaMes) * 100 : 0;

  const totalMargemAcum = vendas.length > 0
    ? vendas.reduce((s, v) => s + ((v.margem_acum ?? 0) * (v.vlrvenda_acum ?? 0)), 0) / (totalVendaAcum || 1)
    : 0;

  const dadosComTotal = [
    ...vendas,
    {
      loja: 'Emp',
      descricao: 'Empresa',
      vl_vda: totalVenda,
      vlr_meta_dia: totalMeta,
      atingido: totalAtingido,
      vlr_perda_dia: totalQuebraDia,
      pct_perda_dia: totalPctQuebraDia,
      vlrvendapromoc: totalVendaPromoc,
      vlrlucro: totalLucro,
      vlrvenda_acum: totalVendaAcum,
      vlr_meta_acum: totalMetaAcum,
      atingido_acum: totalAtingidoAcum,
      vlr_perda_periodo: totalQuebraAcum,
      pct_perda_periodo: totalPctQuebraAcum,
      vlr_meta_mes: totalMetaMes,
      pct_garrafa: totalPctGarrafa,
      margem_acum: totalMargemAcum
    }
  ];

  const exibirGraficosComparativos = vendas.length > 1;

  const unifiedChartData = {
    labels: dadosComTotal.map(v => v.descricao),
    datasets: [
      {
        type: 'bar',
        label: '% Atingido Meta Dia',
        data: dadosComTotal.map(v => v.atingido ?? 0),
        backgroundColor: 'rgba(2, 132, 199, 0.75)',
        borderColor: 'rgba(2, 132, 199, 1)',
        borderWidth: 1,
        borderRadius: 4
      },
      {
        type: 'bar',
        label: '% Promocional',
        data: dadosComTotal.map(v => percPromoPorLinha(v)),
        backgroundColor: 'rgba(244, 63, 94, 0.75)',
        borderColor: 'rgba(244, 63, 94, 1)',
        borderWidth: 1,
        borderRadius: 4
      }
    ]
  };

  const chartVendaPeriodoData = {
    labels: dadosComTotal.map(v => v.descricao),
    datasets: [
      {
        type: 'bar',
        label: '% Atingido Meta Período',
        data: dadosComTotal.map(v => v.atingido_acum ?? 0),
        backgroundColor: 'rgba(16, 185, 129, 0.75)',
        borderColor: 'rgba(16, 185, 129, 1)',
        borderWidth: 1,
        borderRadius: 4,
        yAxisID: 'y'
      },
      {
        type: 'line',
        label: '% Margem Período',
        data: dadosComTotal.map(v => v.margem_acum ?? 0),
        borderColor: '#f59e0b',
        backgroundColor: '#f59e0b',
        borderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
        tension: 0.3,
        yAxisID: 'y1'
      }
    ]
  };

  const chartGarrafaData = {
    labels: dadosComTotal.map(v => v.descricao),
    datasets: [
      {
        type: 'bar',
        label: '% Meta Mês',
        data: dadosComTotal.map(v => v.pct_garrafa ?? 0),
        backgroundColor: 'rgba(139, 92, 246, 0.75)',
        borderColor: 'rgba(139, 92, 246, 1)',
        borderWidth: 1,
        borderRadius: 4,
        yAxisID: 'y'
      },
      {
        type: 'line',
        label: '% Margem Mês',
        data: dadosComTotal.map(v => v.margem_acum ?? 0),
        borderColor: '#f59e0b',
        backgroundColor: '#f59e0b',
        borderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
        tension: 0.3,
        yAxisID: 'y1'
      }
    ]
  };

  /* 🔹 AJUSTE NO DATALABELS PARA EVITAR EMBOLAR OS NÚMEROS */
  const getChartOptions = (titleText, chartType = 1, isZoom = false) => ({
    responsive: true,
    maintainAspectRatio: !isZoom,
    plugins: {
      legend: {
        position: 'top',
        labels: { font: { size: isZoom ? 13 : 10, weight: '600' } }
      },
      title: {
        display: true,
        text: titleText,
        font: { size: isZoom ? 15 : 12, weight: 'bold' },
        color: '#0f172a'
      },
      tooltip: {
        backgroundColor: '#0f172a',
        padding: 8,
        callbacks: {
          title: (items) => items && items[0] ? `Loja: ${dadosComTotal[items[0].dataIndex].descricao}` : '',
          label: (ctx) => {
            const idx = ctx.dataIndex;
            const data = dadosComTotal[idx];
            const margemDia = data.vl_vda > 0 ? ((data.vlrlucro * 100) / data.vl_vda).toFixed(2) : '0.00';
            const margemAcum = (data.margem_acum ?? 0).toFixed(2);

            if (chartType === 1) {
              return [
                `Valor Venda Dia: ${formatCurrency(data.vl_vda)}`,
                `Valor Meta Dia: ${formatCurrency(data.vlr_meta_dia)}`,
                `% Atingido Dia: ${(data.atingido ?? 0).toFixed(2)}%`,
                `Venda Promo: ${formatCurrency(data.vlrvendapromoc)} (${percPromoPorLinha(data).toFixed(2)}%)`,
                `Quebra Dia: ${formatCurrency(data.vlr_perda_dia)} (${(data.pct_perda_dia ?? 0).toFixed(2)}%)`,
                `Margem Dia: ${margemDia}%`
              ];
            } else if (chartType === 2) {
              return [
                `Valor Venda Mês: ${formatCurrency(data.vlrvenda_acum)}`,
                `Valor Meta Período: ${formatCurrency(data.vlr_meta_acum)}`,
                `% Atingido Período: ${(data.atingido_acum ?? 0).toFixed(2)}%`,
                `Quebra Período: ${formatCurrency(data.vlr_perda_periodo)} (${(data.pct_perda_periodo ?? 0).toFixed(2)}%)`,
                `Margem Período: ${margemAcum}%`
              ];
            } else if (chartType === 3) {
              return [
                `Valor Venda Mês: ${formatCurrency(data.vlrvenda_acum)}`,
                `Valor Meta Mês: ${formatCurrency(data.vlr_meta_mes)}`,
                `% Meta Mês: ${(data.pct_garrafa ?? 0).toFixed(2)}%`,
                `Margem Mês: ${margemAcum}%`
              ];
            }
            return `${ctx.dataset.label}: ${(ctx.raw ?? 0).toFixed(2)}%`;
          }
        }
      },
      datalabels: {
        color: (ctx) => (ctx.dataset.type === 'line' ? '#d97706' : '#0f172a'),
        font: { weight: 'bold', size: isZoom ? 10 : (isMobile ? 7 : 8) },
        // 🔹 O % da linha fica acima do ponto amarelo
        // 🔹 O % da barra fica no topo e rotacionado na vertical
        anchor: 'end',
        align: (ctx) => (ctx.dataset.type === 'line' ? 'top' : 'top'),
        offset: (ctx) => (ctx.dataset.type === 'line' ? 2 : 2),
        rotation: (ctx) => (ctx.dataset.type === 'line' ? 0 : -90),
        formatter: (v) => `${(v ?? 0).toFixed(1)}%`
      }
    },
    scales: {
      x: {
        title: { display: true, text: 'Lojas', font: { weight: '600', size: 10 } },
        ticks: { font: { size: isZoom ? 11 : 8 } },
        grid: { display: false }
      },
      y: {
        type: 'linear',
        display: true,
        position: 'left',
        beginAtZero: true,
        max: 120, // 🔹 Escala idêntica para o eixo esquerdo
        title: { display: true, text: 'Atingido (%)', font: { weight: '600', size: 10 } },
        ticks: { callback: (val) => val + '%', font: { size: 9 } },
        grid: { color: '#f1f5f9' }
      },
      y1: {
        type: 'linear',
        display: chartType !== 1,
        position: 'right',
        beginAtZero: true,
        max: 120, // 🔹 IGUALAR A 120%: Faz com que 20% fique na reta correspondente a metade da altura da barra de 40%
        title: { display: true, text: 'Margem (%)', font: { weight: '600', size: 10 } },
        ticks: { callback: (val) => val + '%', font: { size: 9 } },
        grid: { drawOnChartArea: false }
      }
    }
  });

  const handleExpandSecao = (data, lojaDescricao, tipoVisao) => {
    setZoomSecao({ data, lojaDescricao, tipoVisao });
  };

  return (
    <div className="flash-vendas-layout-wrapper">
      <Menu modulo="ARBOR" />

      <LoadingModal show={loading} message={loadingMessage} />
      <FloatingClock seconds={timerSeconds} />

      {!loading && !error && (
        <div className="container-fluid px-3 px-md-4 max-width-container">

          <div className="d-none d-md-flex row g-2 mb-3">
            <div className={exibirGraficosComparativos ? "col-md-4" : "col-md-12"}>
              <div className="chart-container position-relative h-100">
                <button
                  className="btn btn-expand-chart"
                  onClick={() => setZoomChart({ type: 1, title: '% Atingido Meta Dia e Promocional (%)' })}
                  title="Ampliar Gráfico"
                >
                  🔍 Expandir
                </button>
                <Bar ref={chartRef} options={getChartOptions('% Atingido Dia & Promo', 1)} data={unifiedChartData} />
              </div>
            </div>

            {exibirGraficosComparativos && (
              <>
                <div className="col-md-4">
                  <div className="chart-container position-relative h-100">
                    <button
                      className="btn btn-expand-chart"
                      onClick={() => setZoomChart({ type: 2, title: '% Atingido da Meta do Período por Loja' })}
                      title="Ampliar Gráfico"
                    >
                      🔍 Expandir
                    </button>
                    <Bar options={getChartOptions('% Meta Período', 2)} data={chartVendaPeriodoData} />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="chart-container position-relative h-100">
                    <button
                      className="btn btn-expand-chart"
                      onClick={() => setZoomChart({ type: 3, title: '% da Meta do Mês Atingida por Loja' })}
                      title="Ampliar Gráfico"
                    >
                      🔍 Expandir
                    </button>
                    <Bar options={getChartOptions('% Meta Mês', 3)} data={chartGarrafaData} />
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="d-md-none mb-3 pt-4">
            <div className="chart-container position-relative">
              {(activeTabMobile === 'dia' || !exibirGraficosComparativos) && (
                <>
                  <button
                    className="btn btn-expand-chart"
                    onClick={() => setZoomChart({ type: 1, title: '% Atingido Meta Dia e Promocional (%)' })}
                  >
                    🔍
                  </button>
                  <Bar options={getChartOptions('% Atingido Dia & Promo', 1)} data={unifiedChartData} />
                </>
              )}

              {activeTabMobile === 'periodo' && exibirGraficosComparativos && (
                <>
                  <button
                    className="btn btn-expand-chart"
                    onClick={() => setZoomChart({ type: 2, title: '% Atingido da Meta do Período por Loja' })}
                  >
                    🔍
                  </button>
                  <Bar options={getChartOptions('% Meta Período', 2)} data={chartVendaPeriodoData} />
                </>
              )}

              {activeTabMobile === 'mes' && exibirGraficosComparativos && (
                <>
                  <button
                    className="btn btn-expand-chart"
                    onClick={() => setZoomChart({ type: 3, title: '% da Meta do Mês Atingida por Loja' })}
                  >
                    🔍
                  </button>
                  <Bar options={getChartOptions('% Meta Mês', 3)} data={chartGarrafaData} />
                </>
              )}
            </div>

            {exibirGraficosComparativos && (
              <ul className="nav nav-pills nav-justified bg-white p-1 rounded-3 shadow-sm border mt-2">
                <li className="nav-item">
                  <button
                    className={`nav-link btn-sm fw-bold py-1 ${activeTabMobile === 'dia' ? 'active bg-primary text-white' : 'text-dark'}`}
                    onClick={() => setActiveTabMobile('dia')}
                  >
                    Meta Dia
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link btn-sm fw-bold py-1 ${activeTabMobile === 'periodo' ? 'active bg-primary text-white' : 'text-dark'}`}
                    onClick={() => setActiveTabMobile('periodo')}
                  >
                    Meta Período
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link btn-sm fw-bold py-1 ${activeTabMobile === 'mes' ? 'active bg-primary text-white' : 'text-dark'}`}
                    onClick={() => setActiveTabMobile('mes')}
                  >
                    Meta Mês
                  </button>
                </li>
              </ul>
            )}
          </div>

          {!isMobile && (
            <div className="table-frozen-wrapper shadow-sm border rounded-3 mb-4">
              <table className="table table-striped table-hover align-middle m-0 table-compact-fixed">
                <thead className="table-header-frozen">
                  <tr>
                    <th style={{ width: '85px' }}>Descrição</th>
                    <th className="text-end" style={{ width: '80px' }}>Venda Dia</th>
                    <th className="text-end" style={{ width: '80px' }}>Meta Dia</th>
                    <th className="text-end" style={{ width: '55px' }}>% Dia</th>
                    <th className="text-end text-custom-red" style={{ width: '85px' }}>Quebra Dia</th>
                    <th className="text-end text-custom-red" style={{ width: '60px' }}>% Q.Dia</th>
                    <th className="text-end" style={{ width: '85px' }}>Venda Mês</th>
                    <th className="text-end" style={{ width: '85px' }}>Meta Per.</th>
                    <th className="text-end" style={{ width: '55px' }}>% Per.</th>
                    <th className="text-end text-custom-red" style={{ width: '85px' }}>Quebra Per.</th>
                    <th className="text-end text-custom-red" style={{ width: '60px' }}>% Q.Per</th>
                    <th className="text-end" style={{ width: '85px' }}>Meta Mês</th>
                    <th className="text-end" style={{ width: '55px' }}>Mg Dia</th>
                    <th className="text-end" style={{ width: '55px' }}>Mg Per.</th>
                    <th className="text-end" style={{ width: '80px' }}>Venda Promo</th>
                    <th className="text-end" style={{ width: '55px' }}>% Promo</th>
                    <th className="text-center" style={{ width: '55px' }}>Meta %</th>
                    <th className="text-center" style={{ width: '50px' }}>Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {dadosComTotal.map((v, idx) => (
                    <React.Fragment key={idx}>
                      <tr className={v.loja === 'Emp' ? 'fw-bold table-secondary' : ''}>
                        <td className="fw-semibold text-truncate" title={v.descricao}>{v.descricao}</td>
                        <td className="text-end">{formatCurrency(v.vl_vda)}</td>
                        <td className="text-end">{formatCurrency(v.vlr_meta_dia)}</td>
                        <td className="text-end fw-semibold">{(v.atingido ?? 0).toFixed(1)}%</td>

                        <td className="text-end text-custom-red">
                          <div className="d-flex justify-content-end align-items-center gap-1">
                            <span className="fw-semibold">{formatCurrency(v.vlr_perda_dia)}</span>
                            <button
                              type="button"
                              className="btn btn-outline-custom-red btn-xs p-0 border-0"
                              title="Filtrar Quebra Dia"
                              onClick={() => handleOpenTiposPerda(v.loja, 'DIA')}
                            >
                              🔍
                            </button>
                          </div>
                        </td>
                        <td className="text-end text-custom-red fw-semibold">{(v.pct_perda_dia ?? 0).toFixed(1)}%</td>

                        <td className="text-end">{formatCurrency(v.vlrvenda_acum)}</td>
                        <td className="text-end">{formatCurrency(v.vlr_meta_acum)}</td>
                        <td className="text-end fw-semibold">{(v.atingido_acum ?? 0).toFixed(1)}%</td>

                        <td className="text-end text-custom-red">
                          <div className="d-flex justify-content-end align-items-center gap-1">
                            <span className="fw-semibold">{formatCurrency(v.vlr_perda_periodo)}</span>
                            <button
                              type="button"
                              className="btn btn-outline-custom-red btn-xs p-0 border-0"
                              title="Filtrar Quebra Período"
                              onClick={() => handleOpenTiposPerda(v.loja, 'PERIODO')}
                            >
                              🔍
                            </button>
                          </div>
                        </td>
                        <td className="text-end text-custom-red fw-semibold">{(v.pct_perda_periodo ?? 0).toFixed(1)}%</td>

                        <td className="text-end">{formatCurrency(v.vlr_meta_mes)}</td>
                        <td className="text-end">{(v.vl_vda > 0 ? (v.vlrlucro * 100 / v.vl_vda) : 0).toFixed(1)}%</td>
                        <td className="text-end">{(v.margem_acum ?? 0).toFixed(1)}%</td>
                        <td className="text-end">{formatCurrency(v.vlrvendapromoc)}</td>
                        <td className="text-end">{percPromoPorLinha(v).toFixed(1)}%</td>

                        <td className="text-center py-1">
                          <MetaMesProgresso percentual={v.pct_garrafa} />
                        </td>

                        <td className="text-center">
                          <button
                            className="btn btn-primary btn-xs px-2 rounded-pill fw-semibold"
                            onClick={() => handleLojaClick(v.loja)}
                          >
                            {isExpanded(v.loja) ? 'Ocultar' : 'Ver'}
                          </button>
                        </td>
                      </tr>

                      {isExpanded(v.loja) && (
                        <tr>
                          <td colSpan="18" className="bg-light p-2">
                            {secoesLoading[v.loja] ? (
                              <div className="text-center py-3">
                                <div className="spinner-border spinner-border-sm text-custom-red" role="status"></div>
                              </div>
                            ) : (
                              <SecaoGrafico
                                data={secoesData[v.loja]}
                                lojaDescricao={v.descricao}
                                lojaId={v.loja}
                                isMobile={isMobile}
                                onExpandSecao={handleExpandSecao}
                                onOpenTiposPerda={handleOpenTiposPerda}
                              />
                            )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {isMobile && (
            <div className="mt-2">
              {dadosComTotal.map((v, idx) => {
                const percAting = v.atingido ?? 0;
                const percQuebraDia = v.pct_perda_dia ?? 0;
                const percPer = v.atingido_acum ?? 0;
                const percQuebraPer = v.pct_perda_periodo ?? 0;

                return (
                  <div key={idx} className="card mb-3 border-0 shadow-sm rounded-3 overflow-hidden">
                    <div className="card-body p-3">
                      <h5 className="card-title text-center mb-3 fw-bold text-dark">{v.descricao}</h5>

                      <div className="d-flex justify-content-between align-items-center mb-3 px-1" style={{ gap: 4 }}>
                        <div className="text-center flex-fill">
                          <DoubleDoughnutChart
                            percPrincipal={percAting}
                            percQuebra={percQuebraDia}
                            corPrincipal="#0284c7"
                          />
                          <span style={{ fontSize: '0.68rem', fontWeight: '700', display: 'block', marginTop: 4, color: '#64748b' }}>Dia / Quebra</span>
                        </div>

                        <div className="text-center flex-fill">
                          <DoubleDoughnutChart
                            percPrincipal={percPer}
                            percQuebra={percQuebraPer}
                            corPrincipal="#10b981"
                          />
                          <span style={{ fontSize: '0.68rem', fontWeight: '700', display: 'block', marginTop: 4, color: '#64748b' }}>Período / Quebra</span>
                        </div>

                        <div className="text-center flex-fill">
                          <MetaMesProgresso percentual={v.pct_garrafa} />
                          <span style={{ fontSize: '0.68rem', fontWeight: '700', display: 'block', marginTop: 4, color: '#64748b' }}>Meta Mês</span>
                        </div>
                      </div>

                      <div className="card-text text-start mt-2 mb-0 border-top pt-3" style={{ fontSize: '0.8rem', lineHeight: '1.3' }}>
                        <div className="row g-2">
                          <div className="col-6 border-end pe-2">
                            <span className="text-muted d-block">Venda Dia:</span>
                            <strong className="text-dark">{formatCurrency(v.vl_vda)}</strong>
                          </div>
                          <div className="col-6 ps-2">
                            <span className="text-muted d-block">Meta Dia:</span>
                            <strong className="text-dark">{formatCurrency(v.vlr_meta_dia)}</strong>
                          </div>

                          <div className="col-6 border-end pe-2">
                            <span className="text-muted d-block">Venda Mês:</span>
                            <strong className="text-dark">{formatCurrency(v.vlrvenda_acum)}</strong>
                          </div>
                          <div className="col-6 ps-2">
                            <span className="text-muted d-block">Meta Período:</span>
                            <strong className="text-dark">{formatCurrency(v.vlr_meta_acum)}</strong>
                          </div>

                          <div className="col-6 border-end pe-2 text-custom-red">
                            <div className="d-flex align-items-center justify-content-between">
                              <span className="fw-semibold">Quebra Dia:</span>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-custom-red py-0 px-1 rounded-circle"
                                style={{ fontSize: '0.6rem', width: '18px', height: '18px', padding: 0 }}
                                title="Ver detalhes da Quebra Dia"
                                onClick={() => handleOpenTiposPerda(v.loja, 'DIA')}
                              >
                                🔍
                              </button>
                            </div>
                            <strong className="fw-bold">{formatCurrency(v.vlr_perda_dia)}</strong>
                          </div>

                          <div className="col-6 ps-2 text-custom-red">
                            <div className="d-flex align-items-center justify-content-between">
                              <span className="fw-semibold">Quebra Período:</span>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-custom-red py-0 px-1 rounded-circle"
                                style={{ fontSize: '0.6rem', width: '18px', height: '18px', padding: 0 }}
                                title="Ver detalhes da Quebra Período"
                                onClick={() => handleOpenTiposPerda(v.loja, 'PERIODO')}
                              >
                                🔍
                              </button>
                            </div>
                            <strong className="fw-bold">{formatCurrency(v.vlr_perda_periodo)}</strong>
                          </div>

                          <div className="col-6 border-end pe-2">
                            <span className="text-muted d-block">Venda Promo:</span>
                            <strong className="text-primary">{formatCurrency(v.vlrvendapromoc)}</strong>
                          </div>
                          <div className="col-6 ps-2">
                            <span className="text-muted d-block">Meta Mês:</span>
                            <strong className="text-dark">{formatCurrency(v.vlr_meta_mes)}</strong>
                          </div>

                          <div className="col-6 border-end pe-2">
                            <span className="text-muted d-block">Mg Dia:</span>
                            <strong>{(v.vl_vda > 0 ? (v.vlrlucro * 100 / v.vl_vda) : 0).toFixed(1)}%</strong>
                          </div>
                          <div className="col-6 ps-2">
                            <span className="text-muted d-block">Mg Período:</span>
                            <strong>{(v.margem_acum ?? 0).toFixed(1)}%</strong>
                          </div>
                        </div>
                      </div>

                      <div className="text-center mt-3">
                        <button
                          className="btn btn-primary w-100 rounded-pill fw-semibold py-2"
                          onClick={() => handleLojaClick(v.loja)}
                        >
                          {isExpanded(v.loja) ? 'Ocultar Seções' : 'Ver Seções'}
                        </button>
                      </div>
                    </div>

                    {isExpanded(v.loja) && (
                      <div className="card-footer bg-light p-2">
                        {secoesLoading[v.loja] ? (
                          <div className="text-center py-3">
                            <div className="spinner-border spinner-border-sm text-custom-red" role="status"></div>
                          </div>
                        ) : (
                          <SecaoGrafico
                            data={secoesData[v.loja]}
                            lojaDescricao={v.descricao}
                            lojaId={v.loja}
                            isMobile={isMobile}
                            onExpandSecao={handleExpandSecao}
                            onOpenTiposPerda={handleOpenTiposPerda}
                          />
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* Modal - Tipos de Perda */}
      <ModalGenerico
        show={showTiposModal}
        onClose={() => setShowTiposModal(false)}
        title={`Tipos de Quebra - (${selectedTipoQuebra})${selectedSecaoNome ? ` - Seção: ${selectedSecaoNome}` : ''}`}
      >
        {loadingPerdas ? (
          <div className="text-center py-4">
            <div className="spinner-border text-custom-red" role="status"></div>
            <div className="loading-text mt-2 fw-bold text-secondary">A carregar registros...</div>
          </div>
        ) : (
          <div>
            {tiposPerdaData.length > 0 && (
              <div className="d-flex justify-content-end align-items-center mb-3">
                <label className="me-2 fw-semibold text-muted small">Ordenar por:</label>
                <select
                  className="form-select form-select-sm w-auto rounded-3"
                  value={ordemTipos}
                  onChange={(e) => setOrdemTipos(e.target.value)}
                >
                  <option value="VALOR_DESC">Maior Valor</option>
                  <option value="VALOR_ASC">Menor Valor</option>
                  <option value="NOME_ASC">Ordem Alfabética (A-Z)</option>
                  <option value="NOME_DESC">Ordem Alfabética (Z-A)</option>
                </select>
              </div>
            )}

            <div className="list-group list-group-flush border rounded-3 overflow-hidden">
              {getTiposPerdaOrdenados().length === 0 ? (
                <div className="text-center py-4 text-muted">Nenhum registro encontrado.</div>
              ) : (
                getTiposPerdaOrdenados().map((item, idx) => {
                  const tipoNome = item.TIPO || item.tipo || `Operação ${item.CODGERALOPER || item.codgeraloper}`;
                  const codOper = item.CODGERALOPER ?? item.codgeraloper ?? 0;
                  const valor = item.VLRTOTALLANCTOBRT ?? item.vlrtotallanctobrt ?? item.VLRTOTALLANCTOBRTPERIODO ?? item.vlrtotallanctobrtperiodo ?? 0;

                  return (
                    <button
                      key={idx}
                      type="button"
                      className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-2 px-3"
                      onClick={() => handleOpenProdutosPorTipo(codOper, tipoNome)}
                    >
                      <div>
                        <strong className="text-dark">{tipoNome}</strong>
                        <div className="text-muted small">Código Operação: {codOper}</div>
                      </div>
                      <span className="badge bg-custom-red rounded-pill px-3 py-2 fs-6 fw-bold">
                        {formatCurrency(valor)}
                      </span>
                    </button>
                  );
                })
              )}
            </div>
          </div>
        )}
      </ModalGenerico>

      {/* Modal - Produtos */}
      <ModalGenerico
        show={showProdutosModal}
        onClose={() => setShowProdutosModal(false)}
        title={modalProdutosTitle}
      >
        {loadingPerdas ? (
          <div className="text-center py-4">
            <div className="spinner-border text-custom-red" role="status"></div>
            <div className="loading-text mt-2 fw-bold text-secondary">A carregar produtos...</div>
          </div>
        ) : (
          <>
            {produtosPerdaData.length > 0 && (
              <div className="d-flex justify-content-end align-items-center mb-3">
                <label className="me-2 fw-semibold text-muted small">Ordenar por:</label>
                <select
                  className="form-select form-select-sm w-auto rounded-3"
                  value={ordemProdutos}
                  onChange={(e) => setOrdemProdutos(e.target.value)}
                >
                  <option value="VALOR_DESC">Maior Valor</option>
                  <option value="VALOR_ASC">Menor Valor</option>
                  <option value="NOME_ASC">Ordem Alfabética (A-Z)</option>
                  <option value="NOME_DESC">Ordem Alfabética (Z-A)</option>
                </select>
              </div>
            )}

            {isMobile ? (
              <div className="d-flex flex-column gap-2">
                {getProdutosPerdaOrdenados().length === 0 ? (
                  <div className="text-center py-4 text-muted">Nenhum produto encontrado.</div>
                ) : (
                  getProdutosPerdaOrdenados().map((p, idx) => {
                    const codProd = p.SEQPRODUTO ?? p.seqproduto ?? p.CODPRODUTO ?? p.codproduto ?? '-';
                    const descProd = p.DESCRICAO ?? p.descricao ?? p.DESCCOMPLETA ?? p.desccompleta ?? 'Sem Descrição';
                    const qtdProd = p.QTD ?? p.qtd ?? p.QTDLANCTO ?? p.qtdlancto ?? 0;
                    const vlrTotal = p.VALORTOTAL ?? p.valortotal ?? p.VALORLANCTOBRT ?? p.valorlanctobrt ?? 0;

                    return (
                      <div key={idx} className="border rounded-3 p-2 bg-light shadow-sm" style={{ fontSize: '0.8rem' }}>
                        <div className="d-flex justify-content-between align-items-center fw-bold text-dark border-bottom pb-1 mb-1">
                          <span>{descProd}</span>
                          <span className="badge bg-secondary">Cód: {codProd}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="text-muted">Qtd: <strong className="text-dark">{qtdProd}</strong></span>
                          <span className="text-custom-red fw-bold">{formatCurrency(vlrTotal)}</span>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-sm table-striped align-middle">
                  <thead>
                    <tr>
                      <th>Cód.</th>
                      <th>Produto</th>
                      <th className="text-end">Qtd</th>
                      <th className="text-end">Valor Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getProdutosPerdaOrdenados().length === 0 ? (
                      <tr>
                        <td colSpan="4" className="text-center py-4 text-muted">Nenhum produto encontrado.</td>
                      </tr>
                    ) : (
                      getProdutosPerdaOrdenados().map((p, idx) => {
                        const codProd = p.SEQPRODUTO ?? p.seqproduto ?? p.CODPRODUTO ?? p.codproduto ?? '-';
                        const descProd = p.DESCRICAO ?? p.descricao ?? p.DESCCOMPLETA ?? p.desccompleta ?? 'Sem Descrição';
                        const qtdProd = p.QTD ?? p.qtd ?? p.QTDLANCTO ?? p.qtdlancto ?? 0;
                        const vlrTotal = p.VALORTOTAL ?? p.valortotal ?? p.VALORLANCTOBRT ?? p.valorlanctobrt ?? 0;

                        return (
                          <tr key={idx}>
                            <td className="fw-semibold">{codProd}</td>
                            <td>{descProd}</td>
                            <td className="text-end fw-semibold">{qtdProd}</td>
                            <td className="text-end text-custom-red fw-bold">{formatCurrency(vlrTotal)}</td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </ModalGenerico>

      {/* Modal Zoom Gráficos */}
      <ChartZoomModal
        show={!!zoomChart}
        onClose={() => setZoomChart(null)}
        title={zoomChart?.title || 'Gráfico'}
      >
        {zoomChart?.type === 1 && (
          <Bar options={getChartOptions(zoomChart.title, 1, true)} data={unifiedChartData} />
        )}
        {zoomChart?.type === 2 && (
          <Bar options={getChartOptions(zoomChart.title, 2, true)} data={chartVendaPeriodoData} />
        )}
        {zoomChart?.type === 3 && (
          <Bar options={getChartOptions(zoomChart.title, 3, true)} data={chartGarrafaData} />
        )}
      </ChartZoomModal>

      {/* Modal Zoom Seções */}
      <ChartZoomModal
        show={!!zoomSecao}
        onClose={() => setZoomSecao(null)}
        title={`Ampliação - ${zoomSecao?.lojaDescricao}`}
      >
        {zoomSecao && (() => {
          const { data, lojaDescricao, tipoVisao } = zoomSecao;
          const colors = generateUniqueColors(data.length);
          const getValue = (s) => {
            if (tipoVisao === 'PERIODO') return s.atingido_acum ?? 0;
            if (tipoVisao === 'MES') return s.pct_garrafa ?? 0;
            if (tipoVisao === 'Q_DIA') return s.pct_perda_dia ?? s.PCT_PERDA_DIA ?? 0;
            if (tipoVisao === 'Q_PERIODO') return s.pct_perda_periodo ?? s.PCT_PERDA_PERIODO ?? 0;
            return s.atingido ?? 0;
          };
          const secChartData = {
            labels: data.map(s => s.descricao),
            datasets: [{
              label: 'Seção',
              data: data.map(s => getValue(s)),
              backgroundColor: (tipoVisao === 'Q_DIA' || tipoVisao === 'Q_PERIODO') ? 'rgba(153, 27, 27, 0.85)' : colors,
              borderColor: (tipoVisao === 'Q_DIA' || tipoVisao === 'Q_PERIODO') ? 'rgba(128, 0, 0, 1)' : colors,
              borderWidth: 1,
              borderRadius: 4,
              secaoData: data
            }]
          };
          const secOptions = {
            responsive: true,
            indexAxis: 'y',
            maintainAspectRatio: false,
            plugins: {
              legend: { display: false },
              title: { display: true, text: `Seções (${tipoVisao}) - ${lojaDescricao}`, font: { size: 16, weight: 'bold' } },
              tooltip: {
                backgroundColor: '#0f172a',
                padding: 10,
                callbacks: {
                  label: (ctx) => {
                    const secaoData = ctx.dataset.secaoData ? ctx.dataset.secaoData[ctx.dataIndex] : null;
                    if (!secaoData) return `${ctx.raw}%`;
                    const margemDia = (secaoData.margem ?? 0).toFixed(2);
                    const margemAcum = (secaoData.margem_acum ?? 0).toFixed(2);
                    const vlrPerdaDia = secaoData.vlr_perda_dia ?? secaoData.VLR_PERDA_DIA ?? 0;
                    const vlrPerdaPeriodo = secaoData.vlr_perda_periodo ?? secaoData.VLR_PERDA_PERIODO ?? 0;

                    if (tipoVisao === 'Q_DIA') {
                      return [
                        `Valor Quebra Dia: ${formatCurrency(vlrPerdaDia)}`,
                        `% Quebra Dia: ${(secaoData.pct_perda_dia ?? 0).toFixed(2)}%`
                      ];
                    } else if (tipoVisao === 'Q_PERIODO') {
                      return [
                        `Valor Quebra Período: ${formatCurrency(vlrPerdaPeriodo)}`,
                        `% Quebra Período: ${(secaoData.pct_perda_periodo ?? 0).toFixed(2)}%`
                      ];
                    } else if (tipoVisao === 'PERIODO') {
                      return [
                        `Venda Mês: ${formatCurrency(secaoData.vlrvenda_acum)}`,
                        `Meta Período: ${formatCurrency(secaoData.vlr_meta_acum)}`,
                        `% Atingido Período: ${(secaoData.atingido_acum ?? 0).toFixed(2)}%`,
                        `Margem Período: ${margemAcum}%`
                      ];
                    } else if (tipoVisao === 'MES') {
                      return [
                        `Venda Mês: ${formatCurrency(secaoData.vlrvenda_acum)}`,
                        `Meta Mês: ${formatCurrency(secaoData.vlr_meta_mes)}`,
                        `% Meta Mês: ${(secaoData.pct_garrafa ?? 0).toFixed(2)}%`,
                        `Margem Mês: ${margemAcum}%`
                      ];
                    }
                    return [
                      `Venda Dia: ${formatCurrency(secaoData.vl_vda)}`,
                      `Meta Dia: ${formatCurrency(secaoData.vlr_meta_dia)}`,
                      `% Atingido Dia: ${(secaoData.atingido ?? 0).toFixed(2)}%`,
                      `Margem Dia: ${margemDia}%`
                    ];
                  }
                }
              },
              datalabels: { color: '#0f172a', font: { weight: 'bold', size: 11 }, anchor: 'end', align: 'right', formatter: (v) => `${(v ?? 0).toFixed(1)}%` }
            },
            scales: {
              x: { beginAtZero: true, ticks: { callback: (val) => val + '%' }, grid: { color: '#f1f5f9' } }
            }
          };
          return <Bar options={secOptions} data={secChartData} />;
        })()}
      </ChartZoomModal>

      {error && (<div className="container-fluid mt-4 text-center"><div className="alert alert-danger shadow-sm border-0">Erro ao carregar os dados: {error}</div></div>)}

      <Footer className="footer navbar-fixed-bottom" />
    </div>
  );
};

export default FlashVendas;